import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MenuItem} from "primeng/api";
import {AuthenticationService} from "../../../../service/authentication-service";
import {EventService} from "../../../../service/api/event.service";
import {EventResponse} from "../../../model/response/event/event-response.model";
import {AuthtokenResponse} from "../../../model/response/auth/authtoken-response.model";
import {finalize, tap} from "rxjs";
import {ModalService} from "../../../../service/modal.service";
import {EventUtilService} from "../../../../service/utils/event-util.service";
import {MessageToastService} from "../../../../service/message-toast.service";
import {LoadingService} from "../../../../service/loading.service";
import {Menu} from "primeng/menu";
import {Router} from "@angular/router";
import {EventStatus} from "../../../enums/status.enum";
import {PrivilegeService} from "../../../../service/privilege.service";
import {ApiResponse} from "../../../model/response/ApiResponse";

@Component({
    selector: 'app-event-drop-down-menu',
    templateUrl: './event-drop-down-menu.component.html',
    standalone: false
})
export class EventDropDownMenuComponent implements OnInit {

  @Input('isAdmin') isAdmin: boolean = false
  @Input('event') event: EventResponse

  @Output('onBaseSuccess') onBaseSuccess = new EventEmitter<number>()
  @Output('onRestoreToRemoveSuccess') onRestoreToRemoveSuccess = new EventEmitter<EventResponse>()
  @Output('onCloseEventSuccess') onCloseSuccessEmitter = new EventEmitter<number>()
  @Output('onEventRemoveSuccess') onEventRemoveSuccess = new EventEmitter<void>()
  @Output('onEventTreatmentSuccess') onEventTreatmentSuccess = new EventEmitter<number>()
  @Output('onEditSuccess') onEditSuccessEmitter = new EventEmitter<EventResponse>()

  isEventTerminated: boolean = false
  isEventPreDelete: boolean = false

  user = this.authService._user.value;

  @Input('clickEvent')
  set mouseEvent(event: MouseEvent) {
    if (this.event) {
      this.isEventTerminated = this.event.status?.code == EventStatus.CLOSED
      this.isEventPreDelete = this.event.status?.code == EventStatus.PREDELETE
      this.initMenu()
      this.menu?.toggle(event)
    }
  }

  @ViewChild('menu') menu: Menu

  public authUser: AuthtokenResponse

  items: MenuItem[] | undefined;

  showEditEventModal = false;
  showTreatmentModal = false;
  showEditEventImageModal = false;
  showEventDetailInfoModal = false
  showReportModal = false;
  showClosureModal = false;
  showRemoveModal = false;
  showPreRemoveReasonModal = false;

  public isAuthenticated: boolean = false

  isModeratorOrAdmin = false;

  constructor(
    private authService: AuthenticationService,
    private modalService: ModalService,
    private eventService: EventService,
    private eventUtilService: EventUtilService,
    private messageService: MessageToastService,
    private loadingService: LoadingService,
    private privilegeService: PrivilegeService,
    private router: Router
  ) {
  }

  ngOnInit(): void {

    this.isAuthenticated = this.authService.isAuthenticated();
    this.authUser = this.authService._user.getValue();
    this.isModeratorOrAdmin = this.authService.hasPrivilegeRole(this.privilegeService.getRole())

  }

  initMenu() {
    this.items = [
      {
        items: [
          {
            visible: this.canProcessEvent() && !this.isEventTerminated,
            label: 'Dar tratamento',
            icon: 'pi pi-check-square',
            command: () => this.showTreatmentModal = true
          },
          {
            visible: this.isAdmin,
            label: 'Visualizar',
            icon: 'pi pi-eye',
            command: () => this.showEventDetailInfoModal = true
          },
          {
            visible: this.isAdmin,
            label: 'Ir a Ocorrência',
            icon: 'pi pi-arrow-up-right',
            command: () => this.router.navigate(['/ocorrencia/' + this.event.slug]).then()
          },
          {
            visible: this.canEditEvent() && !this.isEventTerminated,
            label: 'Editar Informações',
            icon: 'pi pi-file-edit',
            command: () => this.showEditEventModal = true
          },
          {
            visible: this.canEditEvent() && !this.isEventTerminated,
            label: 'Alterar Imagem',
            icon: 'pi pi-image',
            command: () => this.showEditEventImageModal = true
          },
          {
            visible: this.canRemoveImage() && !this.isEventTerminated,
            label: 'Remover Imagem',
            icon: 'pi pi-trash',
            command: () => this.openRemoveImageModal()
          },
          {
            visible: this.canReportEvent(),
            label: 'Denunciar Ocorrência',
            icon: 'pi pi-ban',
            command: () => this.openReportEventModal()
          },
          {
            visible: this.canConclude() && !this.isEventTerminated && !this.isEventPreDelete,
            label: 'Fechar Ocorrência',
            icon: 'pi pi-check',
            command: () => this.showClosureModal = true
          },
          {
            visible: this.canConclude() && !this.isEventTerminated && !this.isEventPreDelete,
            label: 'Remover Ocorrência',
            icon: 'pi pi-trash',
            command: () => this.showRemoveModal = true
          },
          {
            visible: this.isEventPreDelete,
            label: 'Motivo de Remoção',
            icon: 'pi pi-envelope',
            command: () => this.showPreRemoveReasonModal = true
          }
        ]

      }
    ];
  }

  private canProcessEvent() {
    return (this.user) ? this.event?.status?.code === EventStatus.PENDING && this.isModeratorOrAdmin : false
  }

  isEventOwner() {
    return this.eventService.isEventOwner(this.authUser, this.event)
  }

  private canEditEvent() {
    return (this.user) ? this.isModeratorOrAdmin || this.isEventOwner() : false
  }

  private canReportEvent() {
    return (this.user) ? !this.isEventOwner() && !this.isModeratorOrAdmin : true
  }

  private canConclude() {
    if (this.user) {
      return (this.isModeratorOrAdmin || this.isEventOwner())
    }
    return false
  }

  private canRemoveImage() {
    return (this.event.blurredImagePath != null || this.event.originalImagePath != null) && this.canEditEvent()
  }

  private openRemoveImageModal() {
    this.modalService.simpleConfirmation({
      message: "Tem certeza que deseja remover a imagem?"
    })
      .then(confirmed => {
        if (confirmed) {
          this.apiRemoveImage()
        }
      })
  }

  private openReportEventModal() {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(["/acesso"]).then()
    } else this.showReportModal = true;
  }

  private apiRemoveImage() {
    this.eventService.deleteEventImage(this.event.id)
      .pipe(finalize(() => {
          this.loadingService.setLoading(false)
        }),
        tap({
          next: (response) => {

            this.messageService.success(response.message)
            this.event.blurredImagePath = null
            this.event.originalImagePath = null
            this.displayEventImage()
          }, error: (response) => {
            this.messageService.error(response.message)
          }
        })).subscribe()
  }

  displayEventImage(): string {
    return this.eventUtilService.displayEventImage(this.event);
  }

  //handle modal success --------------------------------------------------------------------
  onEventEditImageSuccess($event: ApiResponse<any>) {
    this.event.blurredImagePath = $event.data?.blurredImagePath ?? null
    this.event.originalImagePath = $event.data?.originalImagePath ?? null
  }

}
